import React from "react";

const sections = [
  {
    title: "1. Éditeur du site",
    body: "Le site hecnos.fr est édité par Hecnos SAS, société par actions simplifiée dont le siège est situé 10 Av. du Stade de France, 93210 Saint-Denis (France). Contact : hello@hecnos.fr — +33 6 99 29 21 71.",
  },
  {
    title: "2. Objet",
    body: "Les présentes conditions ont pour objet de définir les modalités d'utilisation du site hecnos.com. Tout accès au site implique l'acceptation sans réserve des présentes conditions.",
  },
  {
    title: "3. Accès au site",
    body: "L'accès au site est libre et gratuit. Les coûts d'accès et d'utilisation du réseau Internet restent à la charge exclusive de l'utilisateur. Hecnos se réserve le droit d'interrompre temporairement l'accès pour des raisons de maintenance.",
  },
  {
    title: "4. Propriété intellectuelle",
    body: "L'ensemble des contenus présents sur le site (textes, images, logo, vidéos, codes) sont la propriété exclusive de Hecnos SAS ou de ses partenaires. Toute reproduction, représentation ou diffusion sans autorisation écrite préalable est interdite.",
  },
  {
    title: "5. Responsabilité",
    body: "Hecnos SAS s'efforce d'assurer l'exactitude et la mise à jour des informations diffusées, mais ne saurait être tenue responsable des erreurs, omissions ou indisponibilités. L'utilisateur est seul responsable de l'usage qu'il fait des informations consultées.",
  },
  {
    title: "6. Liens hypertextes",
    body: "Le site peut contenir des liens vers des sites tiers. Hecnos SAS n'exerce aucun contrôle sur leur contenu et décline toute responsabilité quant à leur utilisation.",
  },
  {
    title: "7. Données personnelles",
    body: "Le traitement des données personnelles est décrit dans notre Politique de confidentialité, accessible depuis le pied de page.",
  },
  {
    title: "8. Loi applicable",
    body: "Les présentes conditions sont régies par le droit français. Tout litige relatif à leur interprétation ou exécution relève de la compétence exclusive des tribunaux français.",
  },
];

const Terms = () => (
  <div data-testid="terms-page" className="max-w-4xl mx-auto px-6 lg:px-10 pt-16 pb-28">
    <div className="text-xs mono uppercase tracking-[0.3em] text-[#1093f0] mb-4">Mentions légales</div>
    <h1 className="text-5xl lg:text-6xl font-semibold text-[#131517] leading-[1.05] mb-6">
      Conditions d'utilisation
    </h1>
    <p className="text-lg text-[#3f444b] mb-12">
      Dernière mise à jour : {new Date().toLocaleDateString("fr-FR", { year: "numeric", month: "long" })}.
    </p>
    <div className="space-y-10">
      {sections.map((s) => (
        <section key={s.title}>
          <h2 className="text-2xl font-semibold text-[#131517] mb-3">{s.title}</h2>
          <p className="text-[#3f444b] leading-relaxed">{s.body}</p>
        </section>
      ))}
    </div>
  </div>
);

export default Terms;
